export default "__VITE_ASSET__4cabcf2b__"